import { useReactiveVar } from '@apollo/client';
import React from 'react';
import { vars } from '../../reactive';
import FormAccountCode from '../../views/FormPages/Account/Code';
import FormAccountEmail from '../../views/FormPages/Account/Email';
import FormAccountInfo from '../../views/FormPages/Account/Info';
import FormAccountName from '../../views/FormPages/Account/Name';
import FormAccountPostcode from '../../views/FormPages/Account/Postcode';
import FormBookingDateAndTime from '../../views/FormPages/Booking/DateAndTime';
import FormBookingForms from '../../views/FormPages/Booking/Forms';
import FormCheckboxPet from '../../views/FormPages/Booking/Pet';
import FormBookingRecurrenceType from '../../views/FormPages/Booking/RecurrenceType';
import FormSelectRepetition from '../../views/FormPages/Booking/Repetition';
import FormAddPet from '../../views/FormPages/CreatePet/AddPet';
import FormPetBirthday from '../../views/FormPages/CreatePet/Birthday';
import FormSelectBreed from '../../views/FormPages/CreatePet/Breed';
import FormPetGender from '../../views/FormPages/CreatePet/Gender';
import FormAddPetName from '../../views/FormPages/CreatePet/Name';
import FormPetNeutred from '../../views/FormPages/CreatePet/Neutred';
import FormPetType from '../../views/FormPages/CreatePet/Type';
import FormFillSelect from '../../views/FormPages/FormFillSelect/FormFillSelect';
import BookingHandling from '../../views/FormPages/Ordering/BookingHandling';
import FormBookingOrder from '../../views/FormPages/Ordering/BookingOrder';
import BrowserNotSupported from '../../views/FormPages/Ordering/BrowserNotSupported';
import FormFillSummary from '../../views/FormPages/Ordering/FormFillSummary';
import FormsFilled from '../../views/FormPages/Ordering/FormsFilled';
import FormSummary from '../../views/FormPages/Ordering/Summary';
import FormProductCustomizations from '../../views/FormPages/Products/ProductCustomizations';
import FormProducts from '../../views/FormPages/Products/Products';
import Animation from '../Shared/Animation/Animation';
import { FormWrapper } from './styled';
import { FORM_PAGES } from './types';

type Navigation = { params: Record<string, unknown> };

type Pages = Record<FORM_PAGES, (props: { navigation: Navigation }) => JSX.Element>;

const Form = () => {
  const formPage = useReactiveVar(vars.formPage);
  const navigationParams = useReactiveVar(vars.navigationParams);

  const formFormFill = {
    [FORM_PAGES.FORM_SELECT]: () => <FormFillSelect />
  };

  const formProducts = {
    [FORM_PAGES.PRODUCTS]: () => <FormProducts />,
    [FORM_PAGES.PRODUCT_CUSTOMIZATIONS]: () => <FormProductCustomizations />
  };

  const formCreateAccount = {
    [FORM_PAGES.CREATE_ACCOUNT_EMAIL]: () => <FormAccountEmail />,
    [FORM_PAGES.CREATE_ACCOUNT_NAME]: () => <FormAccountName />,
    [FORM_PAGES.CREATE_ACCOUNT_POSTCODE]: () => <FormAccountPostcode />,
    [FORM_PAGES.CREATE_ACCOUNT_CODE]: () => <FormAccountCode />,
    [FORM_PAGES.CREATE_ACCOUNT_CREATED]: () => <FormAccountInfo />
  };

  const formCreatePet = {
    [FORM_PAGES.CREATE_PET_TYPE]: () => <FormPetType />,
    [FORM_PAGES.CREATE_PET_CREATE_PET]: () => <FormAddPetName />,
    [FORM_PAGES.CREATE_PET_GENDER]: () => <FormPetGender />,
    [FORM_PAGES.CREATE_PET_BREED]: () => <FormSelectBreed />,
    [FORM_PAGES.CREATE_PET_DATE]: () => <FormPetBirthday />,
    [FORM_PAGES.CREATE_PET_NEUTRED]: () => <FormPetNeutred />,
    [FORM_PAGES.CREATE_PET_ADD_PET]: () => <FormAddPet />
  };

  const formBooking = {
    [FORM_PAGES.BOOKING_SELECT_PETS]: () => <FormCheckboxPet />,
    [FORM_PAGES.BOOKING_FORMS]: ({ navigation }: { navigation: Navigation }) => <FormBookingForms {...navigation.params} />,
    [FORM_PAGES.BOOKING_CALENDAR_BOOKING_TYPE]: () => <FormBookingRecurrenceType />,
    [FORM_PAGES.BOOKING_CALENDAR_DATE_AND_TIME]: () => <FormBookingDateAndTime />,
    [FORM_PAGES.BOOKING_CALENDAR_DATE_AND_TIME_REPEATITION]: () => <FormSelectRepetition />,
    [FORM_PAGES.BROWSER_NOT_SUPPORTED]: () => <BrowserNotSupported />
  };
  const formOrdering = {
    [FORM_PAGES.BOOKING_SUMMARY]: () => <FormSummary />,
    [FORM_PAGES.BOOKING_ORDER]: () => <FormBookingOrder />,
    [FORM_PAGES.BOOKING_HANDLING]: () => <BookingHandling />,
    [FORM_PAGES.FORM_FILL_SUMMARY]: () => <FormFillSummary />,
    [FORM_PAGES.FORMS_FILLED]: () => <FormsFilled />
  };

  const formPages: Pages = {
    ...formFormFill,
    ...formProducts,
    ...formCreateAccount,
    ...formCreatePet,
    ...formBooking,
    ...formOrdering
  };

  const Component = formPages[formPage];

  const navigation = {
    params: navigationParams || {}
  };

  return (
    <FormWrapper>
      <Animation animationKey={formPage}>
        <>{!!Component && <Component navigation={navigation} />}</>
      </Animation>
    </FormWrapper>
  );
};

export default Form;
